import {
  FilterProvider,
  Flex,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  ModalProvider,
  PageViewProvider,
} from 'dash-ui';

import { GetPropertyByIdQuery } from 'gql/generated.graphql';
import EditMediaFileModal from './components/EditMediaFileModal/EditMediaFileModal';
import MediaPageHeader from './components/MediaPageHeader/MediaPageHeader';
import MoveFileToFolderModal from './components/MoveFileToFolderModal/MoveFileToFolderModal';
import RemoveFolderModal from './components/RemoveFolderModal/RemoveFolderModal';
import RemoveMediaFileModal from './components/RemoveMediaFileModal/RemoveMediaFileModal';
import MediaFilesView from './components/MediaFilesView/MediaFilesView';

const PropertyMedia = ({
  property,
}: {
  property: GetPropertyByIdQuery['getPropertyById'];
}) => {
  return (
    <PaginationProvider>
      <SearchProvider>
        <FilterProvider>
          <SortProvider>
            <PageViewProvider>
              <Flex flexDirection="column">
                <ModalProvider>
                  <>
                    <MediaPageHeader propertyId={property._id} disabled />
                    <MediaFilesView propertyId={property._id} />
                    <RemoveFolderModal />
                    <RemoveMediaFileModal />
                    <EditMediaFileModal />
                    <MoveFileToFolderModal />
                  </>
                </ModalProvider>
              </Flex>
            </PageViewProvider>
          </SortProvider>
        </FilterProvider>
      </SearchProvider>
    </PaginationProvider>
  );
};

export default PropertyMedia;
